<template>
  <div class="base-control pvc-tree applications-tree">
    <applications-tree-node
      class="tree-item"
      v-for="datum in data"
      :max="max"
      :key="datum.id"
      :data="datum"
      :remaining="remaining"
      :sliderStatusId="sliderStatusId"
      :sumInSliders="sumInSliders"
      :inPercentage="inPercentage"
    ></applications-tree-node>
  </div>
</template>

<script>

  import ApplicationsTreeNode from './ApplicationsTreeNode';

  export default {
    name: 'ApplicationsTree',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      max: {
        type: Number,
        default: 0
      },
      remaining: {
        type: Number,
        default: 0
      },
      sliderStatusId: {
        type: Number,
        default: 0
      },
      sumInSliders: {
        type: Number,
        default: 0
      },
      inPercentage: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {

      };
    },
    created () {

    },
    mounted () {

    },
    computed: {
      id () {
        return 'base-applications-tree-' + this._uid;
      },
    },
    methods: {

    },
    components: {
      ApplicationsTreeNode
    }
  };

</script>

<style>

</style>
